




















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import FeriadoModel from "@/models/cadastros/saude/FeriadoModel";
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { PaginationModel } from "@/models/commons/PaginationModel";
import FeriadoFiltro from "@/models/cadastros/saude/FeriadoFiltro";
import { feriadoService } from "@/service/cadastro/saude/feriado/FeriadoService";
import MessageDialog from "@/components/modal/MessageDialog.vue";
import { estadosList } from "@/models/commons/EstadoModel";
import { tiposFeriadosList } from "@/models/cadastros/saude/TipoFeriadoModel"

@Component({
  components:{
    ValidationObserver,
    ValidationProvider,
    MessageDialog
  }
})
export default class ListaFeriados extends Vue {

  $refs!: {
      filtroObserver: InstanceType<typeof ValidationObserver>;
  };

  tiposFeriado = tiposFeriadosList

  feriados:FeriadoModel[] = []

  feriado:FeriadoModel = {};
  estados = estadosList


  loading = false;

  openDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  dialogStyle = "";
  dialogType = "";
  exclusaoDialog = false;

  filtro:FeriadoFiltro = {
    dataInicial: "",
    dataFinal: "",
    tipo: "",
    options: {
      page: 1,
      itemsPerPage: 5,
      itemsLength: 0,
    }
  }
    cabecalho = [
    { text: "Data Feriado", value: "dataFeriado", width: "10%" },
    { text: "Tipo", value: "tipo", width: "15%" },
    { text: "Descrição", value: "descricao", width: "20%" },
    { text: "Estado", value: "estado", width: "15%" },
    { text: "Cidade", value: "cidade.nome", width: "20%" },
    { text: "Ações", value: "actions", sortable: false, width: "20%"   }
  ];

  obterNomeEstado(sigla: string) {
    return estadosList.find(e => e.sigla == sigla)?.nome || "";
  }

  filtrar() {
    if(this.filtro.options.page == 1 ) {
      this.obterDados();
    } else {
      this.filtro.options.page = 1;
    }
  }

  obterDados() {
    feriadoService.obterFeriados(this.filtro).then((res:any) => {
          this.feriados = res.content;
          this.filtro.options.itemsLength = res.totalElements;
      });
  }

  @Watch("filtro.options.page")
  handlePagination() {
    this.obterDados();
  }
  
  @Watch("filtro.options.itemsPerPage")
  handlePageSize() {
    if(this.filtro.options.page == 1) {
      this.obterDados();
    } else {
      this.filtro.options.page = 1;
    }
  }

feriadoExclusao:FeriadoModel = {}

 excluirFeriado(feriado: FeriadoModel) {
    this.feriadoExclusao = feriado;
    this.exclusaoDialog = true;
  }

  excluir() {
    if (this.feriadoExclusao?.id) {
      feriadoService.deletar(
        this.feriadoExclusao?.id
      ).then(
        res => {
          this.dialogTitle = "Sucesso";
          this.dialogMessage = "Feriado excluído com sucesso.";
          this.dialogStyle = "success";
          this.openDialog = true;
          this.exclusaoDialog = false;
          this.filtrar();
        },
        err => {
          this.dialogTitle = "Erro";
          this.dialogMessage = err;
          this.dialogStyle = "error";
          this.openDialog = true;
        }
      );
    }
  }
 

}
